import { useLayoutEffect, useState, useEffect, useRef } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox, SelectBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { assetLocationService } from "../../../apis/apiServices/AssetLocation";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";

export default function AssetLocationListComponent(props) {
  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Location ";
    getAssetLocationList();
  }, []);
  const refDataGrid = useRef(null);
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [AssetLocationList, setAssetLocationList] = useState([]);
  const [projectDropdown, setProjectDropdown] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeViewModal = () => {
    setIsModalOpen(false);
  };

  const [Asstlocation, SetAsstlocation] = useState({
    id: 0,
    name: "",
    code: "",
    projectId: 0,
    isActive: true,
  });

  // <-- use props.featurePermission for permissions (same pattern as Category/SubCategory)
  const featurePermission = props?.featurePermission || {};
  const canAdd = !!featurePermission?.canAdd;
  const canEdit = !!featurePermission?.canEdit;
  const canDelete = !!featurePermission?.canDelete;

  const getAssetLocationList = async () => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetLocationService.getLocationList(0);
      setAssetLocationList(response?.data);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getProjectDropdown = async () => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectList(body);
      setProjectDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAssetLocationList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const newErrors = {};
    if (!Asstlocation.name) newErrors.name = "Please enter location.";
    if (Asstlocation.projectId === 0)
      newErrors.projectId = "Please select project.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }

    try {
      let body = {
        id: Asstlocation.id,
        name: Asstlocation?.name || "",
        code: Asstlocation?.code || "",
        projectId: Asstlocation?.projectId || 0,
        isActive: Asstlocation?.isActive || false,
        ModifiedBy: user?.userId,
      };

      const response = await assetLocationService.addLocation(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setIsSubmitted(false);
        setErrors(response?.errors || {});
        return;
      }

      getAssetLocationList();

      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        navigate(("/Assetlocation", { replace: true }));
        closeModal();
      });
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    SetAsstlocation({
      id: 0,
      name: "",
      code: "",
      isActive: true,
      projectId: 0,
    });
  };

  const handleInputChange = (e, field) => {
    let err = { ...errors };
    if (field === "projectId") {
      err.projectId = "";
    }
    if (field === "name") {
      err.name = "";
    }
    if (field === "code") {
      err.code = "";
    }
    setErrors(err);
    SetAsstlocation((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div>
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };
  const handleRowClick = (e) => {
    SetAsstlocation({
      id: e.data.id,
      name: e.data.name,
      code: e.data.code,
      projectId: e.data.projectId,
      isActive: e.data.isActive,
    });
  };

  // CHANGED: helper to open edit modal and prefill state when editing a row
  const openEditForRow = (rowData) => {
    if (!rowData) return;
    SetAsstlocation({
      id: rowData.id || 0,
      name: rowData.name || "",
      code: rowData.code || "",
      projectId: rowData.projectId || 0,
      isActive: rowData.isActive ?? true,
    });
    setIsCityModalOpen(true);
  };

  // CHANGED: update delete handler to accept id (and still show confirmation)
  const handleDelete = (id) => {
    if (!id) return;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        // TODO: call delete API here if available, e.g. assetLocationService.deleteLocation(id)
        Swal.fire("Deleted", "Location deleted.", "success");
        // refresh list
        getAssetLocationList();
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const onCellPrepared = (e) => {
    if (e.rowType === "header") {
      e.cellElement.style.backgroundColor = "#595959"; // #808080
      e.cellElement.style.color = "White";
    } else {
      e.cellElement.style.color = "#353839";
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              dataSource={AssetLocationList}
              columnAutoWidth={true}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              onRowClick={(e) => handleRowClick(e)}
              allowColumnResizing={false}
              allowColumnReordering={true}
              // onCellPrepared={onCellPrepared}
              width={"100%"}
              onToolbarPreparing={(e) => {
                // CHANGED: conditionally add Add button based on permission
                const items = [];

                if (canAdd) {
                  items.push({
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "plus",
                      text: "Add",
                      hint: "Add",
                      type: "default",
                      stylingMode: "contained",
                      onClick: () => openModal(),
                    },
                  });
                }

                items.push({
                  location: "before",
                  widget: "dxButton",
                  options: {
                    icon: "refresh",
                    text: "Refresh",
                    hint: "Refresh",
                    type: "default",
                    stylingMode: "outlined",
                    onClick: () => getAssetLocationList(),
                  },
                });

                e.toolbarOptions.items.unshift(...items);
              }}
            >
              <HeaderFilter visible={false} />
              <Column
                width="60px"
                caption={""}
                alignment={"center"}
                cellRender={(cellData) => {
                  return (
                    <span>
                      {/* CHANGED: only show edit icon if canEdit true */}
                      {canEdit && (
                        <Icon
                          className="iconify-size mr-2"
                          title="Edit"
                          tooltip="Edit"
                          icon="solar:pen-line-duotone"
                          style={{ cursor: "pointer" }}
                          onClick={() => openEditForRow(cellData.data)}
                        />
                      )}

                      {/* CHANGED: only show delete icon if canDelete true */}
                      {canDelete && (
                        <Icon
                          className="iconify-size"
                          title="Delete"
                          tooltip="Delete"
                          icon="fluent:delete-32-regular"
                          style={{ cursor: "pointer", marginLeft: canEdit ? 8 : 0 }}
                          onClick={() => handleDelete(cellData.data?.id)}
                        />
                      )}
                    </span>
                  );
                }}
              ></Column>
              <Column
                dataField="name"
                caption="Name"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                dataField="code"
                caption="Code"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                dataField="projectName"
                caption="Project"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                dataField="isActive"
                caption="Status"
                cellRender={renderStatusCell}
                alignment="left"
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />

              <Export enabled={false} fileName="Asset Location" />
            </DataGrid>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isCityModalOpen}
        onAfterOpen={async () => {
          await getProjectDropdown();
        }}
        className="react-modal custom-modal-small"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Assett location Modal"
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">
              {Asstlocation?.id
                ? `Update Location [${Asstlocation.name}]`
                : `Add Location`}
            </div>
          </div>

          <div className="modal-body">
            <div className="form-group">
              <label>
                Project&nbsp;<span className="text-danger">*</span>
              </label>
              <SelectBox
                dataSource={projectDropdown}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select project"
                name="projectDropdown"
                displayExpr="projectName"
                valueExpr="id"
                value={Asstlocation.projectId}
                defaultValue={Asstlocation.projectId}
                showClearButton={true}
                disabled={false}
                searchEnabled={true}
                onSelectionChanged={(e) => {
                  SetAsstlocation((prev) => ({
                    ...prev,
                    projectId: e?.selectedItem?.id ?? 0,
                  }));
                }}
              />
              {errors.projectId && (
                <div className="text-danger">{errors.projectId}</div>
              )}
            </div>
            <div className="form-group">
              <label>
                Location&nbsp;<span className="text-danger">*</span>
              </label>
              <TextBox
                className="form-control form-control-sm"
                placeholder="Enter location"
                showClearButton={true}
                height={37}
                valueChangeEvent="keyup"
                value={Asstlocation.name}
                onValueChanged={(e) => handleInputChange(e, "name")}
              />
              {errors.name && <div className="text-danger">{errors.name}</div>}
            </div>
            <div className="form-group">
              <label>Code </label>
              <TextBox
                className="form-control form-control-sm"
                placeholder="Enter code"
                showClearButton={true}
                height={37}
                valueChangeEvent="keyup"
                value={Asstlocation.code}
                onValueChanged={(e) => handleInputChange(e, "code")}
              />
              {errors.code && <div className="text-danger">{errors.code}</div>}
            </div>
            <div className="form-group">
              <CheckBox
                text="Is Active"
                value={Asstlocation.isActive}
                onValueChanged={(e) => handleInputChange(e, "isActive")}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit">
                  <i className="fas fa-check"></i> Submit
                </span>
              )}
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        className="react-modal resmodel"
        onRequestClose={closeViewModal}
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">View Location</div>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <p>
                    <span className="labelview">Code: </span> {Asstlocation.code}
                  </p>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <p>
                    <span className="labelview">Location: </span> {Asstlocation.name}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <div className="form-group">
                  <p>
                    <span className="labelview">Status: </span> {Asstlocation.isActive ? "Active" : "Inactive"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeViewModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Close {" "}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
